import { ExportTypeConstants } from '../export-type.constants';
import { MineTypeModel } from '../models/mime-type.model';
export const MineTypeMap = new Map()
    .set(ExportTypeConstants.PDF, MineTypeModel.pdf)
    .set(ExportTypeConstants.XLSX, MineTypeModel.xlsx)
    .set(ExportTypeConstants.DOCX, MineTypeModel.docx);
